const Footer = ({ is_login = false }) => {
  return (
    <footer className="l-footer">
      {is_login ? (
        <></>
      ) : (
        <div className="p-page-top">
          <a className="p-page-top__link" href="#">
            <span>ページ</span>
            <span>トップへ</span>
          </a>
        </div>
      )}
      <div className="p-copy">
        <small>Copyright ©2024 Shibuya City Office All Rights Reserved.</small>
      </div>
    </footer>
  );
};
export default Footer;
